/**
 * One subscription to the shared active-contract store (2026-08-29).
 *
 * Defect it closes: the critical banner (app shell) and the obligation
 * strip (/today) each ran their own fetch + interval, so a single /today
 * load asked GET /api/reminders/v1/active four times and the two surfaces
 * could disagree for up to 15s after an action. They now read one state
 * and one poll; `refresh()` moves both at once.
 */
import { useCallback, useEffect, useState } from 'react'
import {
  refreshActiveReminders,
  subscribeActiveReminders,
  type ActiveRemindersState,
} from '../../services/reminderService'

export function useActiveReminders(): ActiveRemindersState & {
  refresh: () => Promise<void>
} {
  const [state, setState] = useState<ActiveRemindersState>({
    contracts: [], error: false, loaded: false,
  })

  useEffect(() => subscribeActiveReminders(setState), [])

  const refresh = useCallback(() => refreshActiveReminders(), [])

  return { ...state, refresh }
}
